import DashboardScreenContainer from '../features/containers/dashboard/DashboardScreenContainer';

export default function Dashboard() {
  return <DashboardScreenContainer />;
}
